export 
const MODULE_TYPES = [
  "SCHEME",
  "JOB",
  "SURVEY",
  "NEWS",
  "HOSPITAL",
  // "SERVICES",
  "NEEDS",
  "EXTERNAL",
  "CMS",
  "PROFILE",
  "HOMEPAGE",
  "REFERRAL",
  "SERVICE_CATEGORY",
  "SERVICE_SUBCATEGORY",
  "SERVICE_LISTING",
  "JOB_LISTING",
  "NEED_LISTING",
];

export const MODULE_CONFIG: Record<
  string,
  {
    moduleLabel?: string;
    subModuleLabel?: string;
    hasModule: boolean;
    hasSubModule: boolean;
  }
> = {
  SCHEME: {
    moduleLabel: "Module ID",
    hasModule: true,
    hasSubModule: false,
  },
  JOB: {
    moduleLabel: "Category ID",
    subModuleLabel: "Sub Category ID",
    hasModule: true,
    hasSubModule: false,
  },
  SURVEY: {
    moduleLabel: "Module ID",
    hasModule: true,
    hasSubModule: false,
  },
  HOSPITAL: {
    hasModule: false,
    hasSubModule: false,
  },
  SERVICE_CATEGORY: {
    moduleLabel: "Category ID",
    hasModule: true,
    hasSubModule: false,
  },
  SERVICE_SUBCATEGORY: {
    moduleLabel: "Category ID",
    subModuleLabel: "Sub Category ID",
    hasModule: true,
    hasSubModule: true,
  },
  NEEDS: {
    hasModule: false,
    hasSubModule: false,
  },
  EXTERNAL: {
    moduleLabel: "Deeplink URL",
    hasModule: true,
    hasSubModule: false,
  },
  CMS: {
    moduleLabel: "Module ID",
    hasModule: true,
    hasSubModule: false,
  },
  PROFILE: {
    hasModule: false,
    hasSubModule: false,
  },
  HOMEPAGE: {
    hasModule: false,
    hasSubModule: false,
  },
  REFERRAL: {
    hasModule: false,
    hasSubModule: false,
  },
  SERVICE_LISTING: {
    hasModule: false,
    hasSubModule: false,
  },
  JOB_LISTING: {
    hasModule: false,
    hasSubModule: false,
  },
  NEED_LISTING: {
    hasModule: false,
    hasSubModule: false,
  },
};